/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiContentAccommodation_AiContentInput_write } from '../models/AiContentAccommodation_AiContentInput_write';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AiContentAccommodationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Updates the AiContentAccommodation resource.
     * Updates the AiContentAccommodation resource.
     * @param id AiContentAccommodation identifier
     * @param requestBody The updated AiContentAccommodation resource
     * @returns void
     * @throws ApiError
     */
    public apiAiContentaccommodationsIdPatch(
        id: string,
        requestBody: AiContentAccommodation_AiContentInput_write,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/ai-content/accommodations/{id}',
            path: {
                id: id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                404: `Resource not found`,
                422: `Unprocessable entity`,
            },
        });
    }
}
